module.exports = __webpack_public_path__ + "static/img/hyper-tube_256.09ec3a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube_256.png
// module id = yP3V
// module chunks = 0